// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// http://datav.aliyun.com/portal/school/atlas/area_selector 地图数据
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './utils/dialog'
import './utils/select'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

Vue.prototype.abc = '123123'

import animate from 'animate.css'
// import echarts from "echarts"
// Vue.prototype.$echarts = echarts;
// console.log(echarts)

// 小数保留四位
Vue.prototype.getFloat = function(num) {
  if (num === 0.32985) {
    return 0.3299
  }
  if (num === 0) {
    return num
  } else if (!num) {
    return '--'
  } else {
    num = Math.round(num * Math.pow(10, 4)) / Math.pow(10, 4)
    num = Number(num).toFixed(4)
    return num
  }
}

// 小数保留两位
Vue.prototype.getFixed2 = function(num) {
  if (num === 0) {
    return num
  } else if (!num) {
    return '--'
  } else {
    num = Number(num).toFixed(2)
    return num
  }
}

// 保留任意小数位
Vue.prototype.getScaleNum = function(num,decimal) {
  if (num === 0) {
    return num
  } else if (!num) {
    return '0'
  } else {
    num = Number(num).toFixed(decimal)
    return num
  }
}

import CnRegionPicker from 'cn-region-picker'
Vue.use(CnRegionPicker)

// element-ui 注册
import ElementUI from 'element-ui' // element-ui的全部组件
import 'element-ui/lib/theme-chalk/index.css'
import i18n from './utils/lang'
import enLocale from 'element-ui/lib/locale/lang/en' // 英文版elementUi
import zhLocale from 'element-ui/lib/locale/lang/zh-CN' // 中文版elementUi

Vue.use(ElementUI, { enLocale }) // 使用英文版elementUI
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

// Table组件 注册
import STable from './components/STable'
Vue.component('STable', STable)

// Form组件 注册
import SForm from './components/SForm'
Vue.component('SForm', SForm)

// Tree组件 注册
import STree from './components/STree'
Vue.component('STree', STree)



// TreeNew组件 注册
import StreeNew from './components/StreeNew'
Vue.component('StreeNew', StreeNew)

//解决BUG TREE组件 注册
import GoodStree from './components/GoodStree'
Vue.component('GoodStree', GoodStree)

//解决bug Tree 默认选中 组件
import GoodStreeDetail from './components/GoodStreeDetail'
Vue.component('GoodStreeDetail', GoodStreeDetail)


// City组件 注册
import SCity from './components/SCity'
Vue.component('SCity', SCity)

import CAlarmItem from './components/CAlarmItem'
Vue.component('CAlarmItem', CAlarmItem)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  animate,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js